import { styled } from '@/styled-system/jsx';
import { cva } from '@/styled-system/css';

export const StyledFlex = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export const boxContainerStyles = cva({
  base: {
    padding: 'default',
    borderRadius: '{radii.100}',
    border: '1px solid',
    borderColor: '{colors.gray.300}',
  },
  variants: {
    isEditMode: {
      true: {
        padding: '0px',
        borderWidth: '0px',
        borderColor: 'transparent',
      },
    },
  },
});
